// extracted by mini-css-extract-plugin
export default {"SelectPropertyOwnership":"SelectPropertyOwnership_SelectPropertyOwnership__t9JRL","HiddenInput":"SelectPropertyOwnership_HiddenInput__Y26HT"};